import { Controller } from "@hotwired/stimulus";
import { DirectUploadQueue } from "../../shared/direct_upload_queue";

// Connects to data-controller="logo--header-form-submit"
export default class extends Controller {
  static targets = ["logoPreviewUrl", "logoPreviewName", "logoContainer", "errorMessage"];

  connect() {
    this.registerLibraryFileCreatedEventListener();
    $(".upload-tooltip").tooltipster({
      maxWidth: 300,
      position: "right",
    });
  }

  async submit(event) {
    const submitButton = this.element.querySelector('input[type="submit"]');

    if (!this.validateFormFields()) {
      event.preventDefault();
      submitButton.removeAttribute('name');
      return;
    }

    submitButton.setAttribute('name', 'commit');

    if (this.logoPreviewUrlTarget?.value) {
      event.preventDefault();
      return this.uploadLogoAndSubmitForm();
    }
  }

  validateFormFields() {
    if (this.isFormFieldsEmpty()) {
      this.showContainerError();
      return false;
    } else {
      this.hideContainerError();
      return true;
    }
  }

  isFormFieldsEmpty() {
    const logoTextField = this.element.querySelector("#site_logo_text");
    const logoLibraryFileIdField = this.element.querySelector("#site_logo_library_file_id");

    return (
      !logoTextField.value.trim() &&
      !this.logoPreviewUrlTarget.value.trim() &&
      !logoLibraryFileIdField.value.trim()
    );
  }

  showContainerError() {
    this.logoContainerTarget.classList.add("with-error");
    this.errorMessageTarget.classList.remove("hidden");
    this.logoContainerTarget.scrollIntoView({ behavior: "smooth", block: "center" });
    this.logoContainerTarget.focus();
  }

  hideContainerError() {
    this.logoContainerTarget.classList.remove("with-error");
    this.errorMessageTarget.classList.add("hidden");
  }

  async uploadLogoAndSubmitForm() {
    const logoName = this.logoPreviewNameTarget.value;
    const blob = window.blobs.logo;
    const file = new File([blob], logoName, { type: blob.type });
    const uploader = document.querySelector('#s3_logo_form');
    const uploadQueue = new DirectUploadQueue();
    uploadQueue.push({ file, uploader });

    try {
      await uploadQueue.flush();
    } catch (error) {
      console.error("S3 upload failed", error);
    }
  }

  registerLibraryFileCreatedEventListener() {
    document.addEventListener('library-file-created', this.handleLibraryFileCreatedEvent.bind(this), { once: true });
  }

  handleLibraryFileCreatedEvent(e) {
    const libraryFileId = e.detail.libraryFileId;
    const libraryFileIdField = document.querySelector("#site_logo_library_file_id");

    if (libraryFileIdField) {
      libraryFileIdField.value = libraryFileId;
    }

    this.element.requestSubmit();
  }
}
